import { render } from "./WalletAddres.vue?vue&type=template&id=35055aba&scoped=true"
import script from "./WalletAddres.vue?vue&type=script&lang=js"
export * from "./WalletAddres.vue?vue&type=script&lang=js"

import "./WalletAddres.vue?vue&type=style&index=0&id=35055aba&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-35055aba"

export default script